export class VisitorEvent {
    _customerAccountId;
    _visitorId;
    _currentUrl;
    _clickPath;
    _clickPosition;
    _screenSize;
    _scrollPosition;
    get customerAccountId() {
        return this._customerAccountId;
    }
    get visitorId() {
        return this._visitorId;
    }
    get currentUrl() {
        return this._currentUrl;
    }
    get clickPath() {
        return this._clickPath;
    }
    get clickPosition() {
        return this._clickPosition;
    }
    get screenSize() {
        return this._screenSize;
    }
    get scrollPosition() {
        return this._scrollPosition;
    }
    constructor({ customerAccountId, visitorId, currentUrl, clickPath, clickPosition, screenSize, scrollPosition }) {
        this._customerAccountId = customerAccountId;
        this._visitorId = visitorId;
        this._currentUrl = currentUrl;
        this._clickPath = clickPath;
        this._clickPosition = clickPosition;
        this._screenSize = screenSize;
        this._scrollPosition = scrollPosition;
    }
    toApiKeys() {
        const apiKeys = {
            cid: this._customerAccountId,
            vid: this._visitorId,
            dl: this._currentUrl,
            sr: this._screenSize,
            t: 'VISITOREVENT'
        };
        if (this._clickPath) {
            apiKeys.cp = this._clickPath;
        }
        if (this._clickPosition) {
            apiKeys.cpo = this._clickPosition;
        }
        if (this._scrollPosition) {
            apiKeys.sp = this._scrollPosition;
        }
        return apiKeys;
    }
}
